import { Pipe, PipeTransform } from '@angular/core';
import { JobDetailQuestions } from 'app/Modules/Job/Models/job-side-preview.model';
import * as _ from 'lodash';
import { JobFieldsToDisplayInJobDetails } from 'app/Modules/Job/Models/jobdetails.model';

@Pipe({
  name: 'showPartialJobDetailsFields',
  standalone: true
})
export class ShowPartialJobDetailsFieldsPipe implements PipeTransform {

  transform(aoFields: JobDetailQuestions[] | null, jobFieldsToDisplay: JobFieldsToDisplayInJobDetails | null): JobDetailQuestions[] {
    if (!aoFields || !jobFieldsToDisplay) {
      return [];
    }

    const renderedFields: JobDetailQuestions[] = [];

    if (jobFieldsToDisplay.Position1 != null) {
      const field = _.find(aoFields, { 'QuestionName': jobFieldsToDisplay.Position1.toLowerCase() });
      if (field) renderedFields.push(field);
    }
    if (jobFieldsToDisplay.JobTitle != null) {
      const field = _.find(aoFields, { 'QuestionName': jobFieldsToDisplay.JobTitle.toLowerCase() });
      if (field) renderedFields.push(field);
    }
    if (jobFieldsToDisplay.Position3 && jobFieldsToDisplay.Position3.length > 0) {
      jobFieldsToDisplay.Position3.forEach((value: string) => {
        const field = _.find(aoFields, { 'QuestionName': value.toLowerCase() });
        if (field) renderedFields.push(field);
      });
    }
    if (jobFieldsToDisplay.Summary != null) {
      const field = _.find(aoFields, { 'QuestionName': jobFieldsToDisplay.Summary.toLowerCase() });
      if (field) renderedFields.push(field);
    }

    _.each(renderedFields, function (opt) {
      if (opt != null) {
        if (jobFieldsToDisplay.Position1 != null && opt.QuestionName == jobFieldsToDisplay.Position1.toLowerCase())
          opt.ClassName = "position1";
        else if (jobFieldsToDisplay.JobTitle != null && opt.QuestionName == jobFieldsToDisplay.JobTitle.toLowerCase()) {
          opt.ClassName = "jobtitle";
        }
        else if (jobFieldsToDisplay.Position3 && jobFieldsToDisplay.Position3.length > 0 && jobFieldsToDisplay.Position3.indexOf(opt.QuestionName.toLowerCase()) >= 0)
          opt.ClassName = "position3";
      }
    });

    const lastUpdatedQuestions = _.filter(aoFields, { "QuestionName": "lastupdated" });
    const lastUpdatedValue = _.map(lastUpdatedQuestions, "AnswerValue").toString();

    if (jobFieldsToDisplay.Position1 != null && jobFieldsToDisplay.Position1.toLowerCase() == "lastupdated" && lastUpdatedValue.indexOf("T") > 0) {
      const asDate = lastUpdatedValue.split("T")[0].toString().split("-"); //Date Format is : 2014-08-11T00:00:00Z from Solr 
      if (lastUpdatedQuestions.length > 0) {
        lastUpdatedQuestions[0].AnswerValue = asDate[1] + "/" + _.parseInt(asDate[2]) + "/" + _.parseInt(asDate[0]); // Changed Date Format is : 08/11/2014
      }
    }

    return renderedFields;
  }

}
